import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Chat from "@material-ui/icons/Chat";
import VerifiedUser from "@material-ui/icons/VerifiedUser";
import Fingerprint from "@material-ui/icons/Fingerprint";
import GroupWork from "@material-ui/icons/GroupWork";
import Extension from "@material-ui/icons/Extension";
import WatchLater from "@material-ui/icons/WatchLater";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import Button from "components/CustomButtons/Button.jsx";

import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.jsx";

function SectionFederalGovernmentFeatures({ ...props }) {
  const { classes, ...rest } = props;
  return (
    <div className="cd-section" {...rest}>
      <div className={classes.container}>
        {/* Feature 1 START */}
        <div className={classes.features1}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto}`}
            >
              <h2
                className={`${classes.title} ${classes.mlAuto} ${
                  classes.mrAuto
                }`}
              >
                Next Generation of Global Leaders
              </h2>
              <h5 className={classes.description}>
                Australia Awards is a prestigious international scholarship and
                short course program offered by the Department of Foreign
                Affairs and Trade. It has been supported for the last 60 years
                by the Australian Government. The program offers the next
                generation of global leaders an opportunity to undertake study,
                research and professional development in Australia. FRANK works
                with scholars from Indonesia, Cambodia, PNG, India, Nepal and
                many other countries. <br /> Here is an example of our work.{" "}
                <br />
                <br />
                <Button
                  color="danger"
                  size="sm"
                  href="https://www.australiaawardsindonesia.org/index.php/article/detail/325/15/sydney-commencing-students-focus-on-professional-linkages"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  More Info
                </Button>
              </h5>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={4} md={4}>
              <InfoArea
                vertical
                icon={Chat}
                title="Engaging Government Webinar Series"
                description="FRANK works with Australia Awards scholars to facilitate engaging conversation and dialogue about NSW Government Priorities like the Premier's Priorities, Health & Infrastructure."
                iconColor="info"
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <InfoArea
                vertical
                icon={VerifiedUser}
                title="Online Video Learning Programs"
                description="FRANK works with Australia Awards Program provider, Scope Global to deliver innovative online learning programs for Australia Awards scholars."
                iconColor="info"
              />
            </GridItem>
            <GridItem xs={12} sm={4} md={4}>
              <InfoArea
                vertical
                icon={Fingerprint}
                title="Face to Face Learning"
                description="FRANK works with Australia Awards Program provider, Coffey International to deliver engaging face to face learning programs for Australia Awards scholars."
                iconColor="info"
              />
            </GridItem>
          </GridContainer>
        </div>
        {/* Feature 1 END */}

        {/* Feature 3 START */}
        <div className={classes.features3}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={`${classes.mlAuto} ${classes.mrAuto} ${
                classes.textCenter
              }`}
            >
              <h2 className={classes.title}>
                What topics do we cover for Australia Awards Scholars?
              </h2>
            </GridItem>

            <GridItem xs={12} sm={6} md={6}>
              <InfoArea
                className={classes.infoArea}
                icon={Extension}
                title="MODULE: Team Leadership & Cultural Intelligence"
                description="FRANK delivers training on how to excel in a global teamwork environment. We look at the nuances of global leadership practice including conflict resolution and communication strategies."
                iconColor="info"
              />
              <InfoArea
                className={classes.infoArea}
                icon={GroupWork}
                title="MODULE: Leadership in a Post-Covid World"
                description="As Covid recreates the world of work and brings digital leadership to the forefront, FRANK is creating new & innovative content to ensure scholars are prepared for this 'new normal.'"
                iconColor="info"
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <InfoArea
                className={classes.infoArea}
                icon={WatchLater}
                title="MODULE: Professional Linkages & Networking"
                description="FRANK trains Australia Awards scholars on how to build professional networks in Australia and understand the Australian business environment as well as foster both ASEAN and global network building skills. "
                iconColor="info"
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    </div>
  );
}

export default withStyles(featuresStyle)(SectionFederalGovernmentFeatures);
